/**
 * Общие куски стилей из макета.
 *
 * В прототипе всё было инлайном с `all:unset` на кнопках — здесь то же самое,
 * только вынесено в переиспользуемые объекты, чтобы значения не разъезжались
 * между экранами. Ховеры и фокусы живут классами в index.html.
 */
import type { CSSProperties } from 'react';

/** Сброс кнопки: ровно то, что делал `style="all:unset"` в прототипе. */
export const btn: CSSProperties = { all: 'unset', cursor: 'pointer' };

export const panel: CSSProperties = {
  border: '1px solid var(--line)',
  borderRadius: 'var(--r)',
  background: 'var(--panel)'
};

export const panelPad: CSSProperties = {
  ...panel,
  padding: '18px 20px'
};

export const panelCol: CSSProperties = {
  ...panelPad,
  display: 'flex',
  flexDirection: 'column',
  gap: 14
};

export const mono: CSSProperties = { fontFamily: 'var(--fm)' };

export const head: CSSProperties = { fontFamily: 'var(--fh)' };

export const sectionTitle: CSSProperties = { fontWeight: 600, fontSize: 14 };

export const divider: CSSProperties = { height: 1, background: 'var(--line)' };

/** Кнопка-пилюля в переключателях (вид/режим/оболочка). */
export function pill(on: boolean): CSSProperties {
  return {
    ...btn,
    padding: '5px 12px',
    borderRadius: 99,
    fontSize: 11.5,
    fontWeight: 600,
    whiteSpace: 'nowrap',
    background: on ? 'var(--acc)' : 'transparent',
    color: on ? 'var(--accInk)' : 'var(--ink3)'
  };
}

/** Контейнер группы пилюль. */
export const pillGroup: CSSProperties = {
  display: 'flex',
  gap: 3,
  padding: 3,
  borderRadius: 99,
  background: 'var(--panel2)',
  border: '1px solid var(--line)'
};

/** Первичная кнопка действия. */
export const primary: CSSProperties = {
  ...btn,
  padding: '12px 20px',
  borderRadius: 'var(--rs)',
  background: 'var(--acc)',
  color: 'var(--accInk)',
  fontSize: 13.5,
  fontWeight: 600,
  whiteSpace: 'nowrap'
};

/** Вторичная кнопка — рамка без заливки. */
export const secondary: CSSProperties = {
  ...btn,
  padding: '9px 15px',
  borderRadius: 'var(--rs)',
  border: '1px solid var(--line)',
  fontSize: 12.5,
  color: 'var(--ink2)'
};

export const input: CSSProperties = {
  boxSizing: 'border-box',
  padding: '9px 12px',
  borderRadius: 'var(--rs)',
  border: '1px solid var(--line)',
  background: 'var(--panel2)',
  color: 'var(--ink)',
  fontFamily: 'var(--fm)',
  fontSize: 12,
  outline: 'none'
};

export const cellBorder: CSSProperties = { borderBottom: '1px solid var(--line)' };

export const ellipsis: CSSProperties = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
};
